module.exports = __webpack_public_path__ + "static/media/Animal-Health.bafa82ce.jpg";